import { notifySaveSuccess } from '../utils/saveNotification';
import { useEffect, useState } from 'react';
import { Page, Card, Text, BlockStack, Button, InlineStack } from '../components/admin-ui';
import { settingsRequest, settingsError } from '../api/adminSettings';
import { SecretField, SettingsFeedback, SettingsLoading } from '../components/SettingsFields';

export default function GoogleMaps() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const load = async () => {
    setLoading(true); setError('');
    try { setData(await settingsRequest('g-maps-settings')); }
    catch (e) { setError(settingsError(e)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const save = async () => {
    setSaving(true); setError(''); setSuccess('');
    try { setData(await settingsRequest('u-maps-settings', { g_map_api_key: data.g_map_api_key })); setSuccess('Google Maps key saved.'); notifySaveSuccess(); }
    catch (e) { setError(settingsError(e)); }
    finally { setSaving(false); }
  };
  return <Page><div className="settings-stack"><SettingsFeedback error={error} success={success} retry={!data ? load : undefined} />
    {loading ? <SettingsLoading /> : data && <Card><BlockStack gap="400">
      <Text as="h2" variant="headingLg">Google Maps</Text><Text as="p" tone="subdued">Manage the shared key for address autocomplete.</Text>
      <SecretField label="Google Maps API key" value={data.g_map_api_key || ''} disabled={saving}
        onChange={value => { setData({ g_map_api_key: value }); setSuccess(''); }}
        helpText="Used by online checkout and COD. COD autocomplete is enabled in COD settings." />
      <InlineStack align="end"><Button variant="primary" onClick={save} loading={saving}>Save</Button></InlineStack>
    </BlockStack></Card>}
  </div></Page>;
}
